"use client";


import React from "react";
import {useLayoutContext} from "../context";
import ChatBubbleOvalLeftEllipsisIcon from "@heroicons/react/24/outline/ChatBubbleOvalLeftEllipsisIcon";
import {usePhrase} from "../../i18n";

const ChatButton = ({_t}) => {

    const t = usePhrase(_t);
    const {toggleLiveChat} = useLayoutContext();

    return <div className={'flex items-center border-r border-r-black pr-2 mr-2 cursor-pointer'} onClick={() => toggleLiveChat()}>
        <span><ChatBubbleOvalLeftEllipsisIcon className={'w-6 h-6 mr-1'}/></span>
        <span className={'text-sm'}>{t('Live Chat')}</span>
    </div>

}

export default ChatButton;